import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import bannerLogo from '../images/Jook_Web_White.png';

import api from '../utils/Api';
import { authContext } from '../contexts/AuthContext';

import './NotFoundView.scss';

type Accepted = { name: string; playerIdentifier: string };

/**
 * Where an admin invite link lands. A signed-out visitor is sent to sign in or sign up
 * first and comes back here after, and the invite is accepted for whoever is signed in.
 */
const InviteView = () => {
  const { token } = useParams<{ token: string }>();
  const context = useContext(authContext);
  const [accepted, setAccepted] = useState<Accepted>(null);
  const [error, setError] = useState<string>(null);

  useEffect(() => {
    api
      .players('invites/accept', 'POST', context.auth.token, { token })
      .then(response => setAccepted(response))
      .catch(e => setError(e.message));
  }, [token]);

  return (
    <div className="notfound">
      <div className="notfound-header">
        <img className="notfound-logo" src={bannerLogo} alt="Jookable" />
      </div>

      <div className="notfound-body">
        <div className="notfound-panel">
          {!accepted && !error && <h1 className="notfound-title">Accepting the invite</h1>}

          {!!accepted && (
            <>
              <h1 className="notfound-title">You're an admin of {accepted.name}</h1>
              <p className="notfound-message">
                You can skip, move, remove and add songs from its control panel. It is on your home screen too.
              </p>
              <Link className="notfound-link" to={`/control/${accepted.playerIdentifier}`}>
                Open the control panel
              </Link>
            </>
          )}

          {!!error && (
            <>
              <h1 className="notfound-title">That invite did not work</h1>
              <p className="notfound-message">{error} Ask the owner to send a new one.</p>
              <Link className="notfound-link" to="/home">
                Back to home
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default InviteView;
